<template>
  <el-dialog :visible.sync="dialogVisible" :title="title" width="30%">
    <p>{{ content }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button class="btn-red" @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'todo',
  props: {
    title: {
      type: String,
      default: '功能还未开放'
    },
    content: {
      type: String,
      default: '此功能尚未开放，敬请期待。'
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    }
  }
}
</script>

<style>

</style>
